/* eslint-disable */
// Define assets path "On The Fly"
__webpack_public_path__ = window.inx.params.project.path.assets;
/* eslint-enable */

import "./main";
import "./main_new";
import showInboxNews from './widget/news-client';
import biscuit from 'tbJSsrc/utils/cookie-handler';

const fireUpPortal = () => {
    const { inx, INBOX, NEWPORTAL } = window;
    const { params: { user }} = inx;

    if (user.email && user.email.length > 0) {
        import(
            /* webpackChunkName: "mail-panel" */
            './widget/mail-list'
        ).then(({ default: init }) =>  init(inx, INBOX));
    }

    //JS based double-submit CSRF protection
    //https://cheatsheetseries.owasp.org/cheatsheets/Cross-Site_Request_Forgery_Prevention_Cheat_Sheet.html#double-submit-cookie
    if (inx.is_static) {
        //random token generation
        let chars = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let password = '';
        const array = new Uint32Array(chars.length);
        window.crypto.getRandomValues(array);
        for (let i = 0; i < 28; i++) {
            password += chars[array[i] % chars.length];
        }
        const csrfDoubleSubmitToken = password;

        const doubleSubmitCookieData = { name: 'csrf_double_submit', value: csrfDoubleSubmitToken };
        // console.log(['generated new token', doubleSubmitCookieData]);
        const domainName =  inx.site ? inx.site : 'inbox.lv';
        biscuit.setIt(doubleSubmitCookieData.name, doubleSubmitCookieData.value, null, '/', domainName, true, 'lax');

        //we need to manually synchronize lang (it was done previously in php)
        const htmlLang = document.querySelector('html').getAttribute('lang');
        biscuit.setIt('language', htmlLang, null, '/', domainName, true, 'lax');

        const csrfDoubleSumitField = document.querySelector('input[name=_token]');
        if (csrfDoubleSumitField) {
            csrfDoubleSumitField.value = csrfDoubleSubmitToken;
        }
    }

    // Show inbox news when enabled
    inx.newsClient && showInboxNews();

    /*
    NOTE:
        Global variable "NEWPORTAL" is undefined on the error pages
        This means "NEWPORTAL" CAN NOT be defined as external in webpack.config.js
    */
    if (NEWPORTAL) {
        import(
            /* webpackChunkName: "module-news" */
            './news/run_news'
        ).then(({ default: init }) => init(NEWPORTAL));
    }
};


document.addEventListener("DOMContentLoaded", fireUpPortal);
